export default __webpack_public_path__ + "static/media/Deacon's Belt of the Sacred Mountain.11d97209.jpg";